<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<p style="text-align: center; padding-top:150px;"><em>In seeking wisdom, thou art wise;</em></p>
<p style="text-align: center;"><em>in supposing thou hast acquired it,</em></p>
<p style="text-align: center;"><em>thou art foolish</em>.</p>
<br/>
<p style="text-align: right;"><em>– Rabbi Ben Azai</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?16200a4f